import { getDutchPaginatorIntl } from '@helpers/custom-pagination';
const ɵ0 = getDutchPaginatorIntl();
export class MaterialModule {
}
export { ɵ0 };
